// extracted by mini-css-extract-plugin
export default {"modal_header":"bill_modal_header__hVa4H"};